import { Flex, Box, Text, Image } from '@chakra-ui/react';

import CarouselSlide from './CarouselSlide';

import elipseSrc from '../../assets/img/elipse.svg';

// 1st carousel component
const Carousel = () => {
  return (
    <Flex direction="column" justifyContent="center">
      <Box mb={5} maxW="640px">
        <Text
          color="primary.default"
          w={{
            xl: '90%',
            '2xl': '100%',
          }}
          fontSize={{ md: '1.3em', lg: '1.5rem', xl: '1.4em', '2xl': '2em' }}
          lineHeight={{ md: '1.5em', lg: '1.5em', xl: '1.6em', '2xl': '1.7em' }}
          textStyle="headingSemiBold"
        >
          Remarkable stories about events from eyewitnesses testimonies.
        </Text>
      </Box>
      <Box pos="relative">
        <Image
          src={elipseSrc}
          pos="absolute"
          bottom={{ base: '-40px', '2xl': 'calc(-0.15*100vh)' }}
          right="max(-124px, calc(20px - 0.075*100vw))"
          w="calc(0.25*100vw)"
          // border="solid 1px black"
          // borderRadius="100%"
        />
        <CarouselSlide />
      </Box>
    </Flex>
  );
};

export default Carousel;
